ModalController.$inject = ['wsModalService'];

export default function ModalController(wsModalService) {
  const vm = this;
  vm.dismiss = wsModalService.dismiss;
  vm.action = wsModalService.action;
}



// WEBPACK FOOTER //
// ./src/layout/modal-deprecated/ws-modal.controller.js